import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClientService } from '../../components/client.service';
import { RequestNewPassClient } from '../../data';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-changue-pass-client',
  templateUrl: './changue-pass-client.component.html',
  styleUrls: ['./changue-pass-client.component.scss']
})
export class ChanguePassClientComponent {
  form: FormGroup;
  request: RequestNewPassClient;
  newPass: string;
  idClient: number = 0;

  constructor(@Inject(MAT_DIALOG_DATA)public data: number, public dialogRef: MatDialogRef<ChanguePassClientComponent>, private fb: FormBuilder, private clientService: ClientService) {
    this.idClient = data;
  }

  ngOnInit() {
    console.log("Id: ", this.data);
    this.form = this.fb.group({
      newPass: ['', [Validators.required, Validators.minLength(8), this.passwordStrengthValidator]],
      verifyNewPass: ['', [Validators.required]]
    }, { validators: this.passwordMatchValidator });
  }

  public cerrarDialogo() {
    this.dialogRef.close();
  }

  public passwordStrengthValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) {
      return null;
    }
    const hasUpperCase = /[A-Z]+/.test(value);
    const hasSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]+/.test(value);
    const passwordValid = hasUpperCase && hasSpecialCharacter;
    if (!passwordValid) {
      return { 
        passwordStrength: true 
      };
    }
    return null;
  }

  public passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const formGroup = control as FormGroup;
    const newPass = formGroup.get('newPass')?.value;
    const verifyNewPass = formGroup.get('verifyNewPass')?.value;
    if (newPass !== verifyNewPass) {
      return { passwordMismatch: true };
    }
    return null;
  }

  public submit() {
    this.request = {
      clientUserId: this.idClient,
      newPassword: this.form.get('newPass')?.value
    };
    this.clientService.updatePassUserClient(this.request).subscribe({
      next: (response) => {
        console.log("Exitoso: ", response);
        Swal.fire({
          title: 'Actualizada Exitosamente',
          icon: 'success',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar'
        });
      },
      error: (err) => {
        console.log("Error: ", err);
      }
    });
  }

}
